import { Tooltip, TooltipContent, TooltipTrigger } from 'cpool-components/general/Tooltip';
import { useTranslation } from 'react-i18next';

import { getChatEntryBlockedKey } from '~/features/whatsapp/utils/getChatEntryBlockedKey';
import type { ChatEntryState } from '~/features/whatsapp/utils/resolveChatEntryState';
import { cn } from '~/utils/cnTailwind';

type Props = {
    children: React.ReactNode;
    className?: string;
    state: ChatEntryState;
};

// disabled buttons fire no pointer events, so the span carries the tooltip
export const ChatEntryDisabledTooltip: React.FC<Props> = ({ children, className, state }) => {
    const { t } = useTranslation();
    const key = getChatEntryBlockedKey(state);
    if (!key) return <>{children}</>;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span className={cn('inline-flex', className)} data-testid="chat-entry-disabled">
                    {children}
                </span>
            </TooltipTrigger>
            <TooltipContent>{t(key)}</TooltipContent>
        </Tooltip>
    );
};
